
import * as kontentAiProviderRuntime$gCW2XoCL_U_45BVCkgd7zj1clRxq4yZ0y7ZHt0zNu_ocY from '/working_dir/src/providers/kontent-ai-image-provider.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "kontentAiProvider",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ]
}

imageOptions.providers = {
  ['kontentAiProvider']: { provider: kontentAiProviderRuntime$gCW2XoCL_U_45BVCkgd7zj1clRxq4yZ0y7ZHt0zNu_ocY, defaults: undefined }
}
        